import { Component, Prop, Vue } from 'vue-property-decorator';
import { CustomerRule } from '@shared/modules/products/models/customer-rule.interface';
import CustomerTableDefaultIndicator from '../customer-table-default-indicator/customer-table-default-indicator.component.vue';
import { Units } from '../../../diemaker/enums/units-enum';
import { BaseConfig } from '@shared/base-config';

@Component({
    components: {
        CustomerTableDefaultIndicator
    }
})
export default class CustomerRules extends Vue {

    @Prop({default: []}) data!: CustomerRule[];
    @Prop() unit!: Units;

    get headers() {
        const headers: any = [
            {text: this.$i18n.t('flatDies.rules'), align: 'start', value: 'selectedForCustomer', width: '50px'},
            {text: this.$i18n.t('flatDies.default'), align: 'start', value: 'default', width: '50px'},
            {text: this.$i18n.t('flatDies.thickness'), align: 'start', value: 'thickness', width: '150px'},
            {text: this.$i18n.t('flatDies.brand'), value: 'brand'},

        ];
        if (BaseConfig.projectType !== 'customer') {
            headers.push({text: this.priceLabel, value: 'price', width: '190px', hidden: true});
        }
        return headers;
    }

    get currency(): string {
        return this.$store.getters.diemaker?.internalCurrency || this.$store.getters.diemaker?.currency;
    }

    get priceLabel(): string {
        return this.$i18n.t('flatDies.price') + ` (${this.currency}/${this.unit === Units.MM ? 'm' : 'ft'})`;
    }

    setSelected(rule: CustomerRule) {
        this.$emit('selectedChange', rule);
        if (!rule.selectedForCustomer && rule.default) {
            rule.default = false;
            const firstSelected = this.data.find((r) => r.selectedForCustomer);
            if (firstSelected) {
                this.setDefault(firstSelected);
            }
        }
    }

    setDefault(rule: CustomerRule) {
        const currentDefault = this.data.find((r) => r.default);
        if (currentDefault && currentDefault.id !== rule.id) {
            currentDefault.default = false;
        }
        rule.default = !rule.default;
        rule.selectedForCustomer = true;
        this.$emit('defaultChange', rule);
    }
}
